// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-inline: 24px;
  background-color: white;
  padding: 20px 20px;
  box-shadow: 0px -4px 15px 0px rgba(79, 97, 79, 0.2509803922);
}
.header .logo {
  height: 50px;
  max-width: 65px;
}
.header ion-button h4 {
  color: white;
  text-transform: capitalize;
  font-size: 20px;
  padding-left: 10px;
}
.header .title {
  font-size: 16px;
  color: #000;
}
.flag-item {
  margin-right: 10px;
}
.flag-item ion-img {
  width: 45px;
  border: 2px solid var(--ion-color-primary);
  border-radius: 50%;
  padding: 2px;
}

.block_info {
  display: flex;
  align-items: center;
}

@media (max-width: 992px) {
  .login {
    display: none;
  }
}

.bsg-logo-button {
  background: transparent;
}

/* BSG-compliant styles for header */
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 15px;
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Logo button styles */
.bsg-logo-button {
  background: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  /* Accessibility focus styles */
  /* Hover state for visual feedback */
  /* Active state when pressed */
}
.bsg-logo-button:focus {
  outline: 2px solid var(--ion-color-primary, #7EA769);
  outline-offset: 2px;
  border-radius: 4px;
}
.bsg-logo-button:hover {
  opacity: 0.9;
}
.bsg-logo-button:active {
  opacity: 0.8;
}

.logo {
  height: 30px;
  width: auto;
}

/* Header controls */
.block_info {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* Language selector button */
.bsg-language-button {
  background: transparent;
  border: none;
  padding: 5px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  /* Accessibility focus styles */
  /* Hover and active states */
}
.bsg-language-button:focus {
  outline: 2px solid var(--ion-color-primary, #7EA769);
  outline-offset: 2px;
}
.bsg-language-button:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.bsg-language-button:active {
  background-color: rgba(0, 0, 0, 0.1);
}
.bsg-language-button ion-img {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  overflow: hidden;
}

/* High contrast mode support */
.bsg-high-contrast {
  /* Add border around the flag for visibility */
}
.bsg-high-contrast .header {
  background-color: #000000;
  border-bottom: 2px solid #ffffff;
  box-shadow: none;
}
.bsg-high-contrast .bsg-logo-button:focus,
.bsg-high-contrast .bsg-language-button:focus {
  outline: 3px dashed #ffff00;
  outline-offset: 3px;
}
.bsg-high-contrast .bsg-logo-button:hover,
.bsg-high-contrast .bsg-language-button:hover {
  background-color: #333333;
}
.bsg-high-contrast .bsg-language-button ion-img {
  border: 1px solid #ffffff;
}

/* Keyboard navigation mode specific styles */
.bsg-keyboard-mode .bsg-logo-button:focus,
.bsg-keyboard-mode .bsg-language-button:focus,
.bsg-keyboard-mode app-burger-btn:focus {
  outline: 2px solid var(--ion-color-primary, #7EA769);
  outline-offset: 2px;
  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/app/components/header/header.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,WAAA;EAEA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EAEA,kBAAA;EACA,4DAAA;AAHD;AAKC;EACC,YAAA;EACA,eAAA;AAHF;AAME;EACC,YAAA;EACA,0BAAA;EACA,eAAA;EACA,kBAAA;AAJH;AAOC;EACC,eAAA;EACA,WAAA;AALF;AAaA;EACC,kBAAA;AAXD;AAYC;EACC,WAAA;EACA,0CAAA;EACA,kBAAA;EACA,YAAA;AAVF;;AAcA;EACC,aAAA;EACA,mBAAA;AAXD;;AC9BE;ED2CF;IAEE,aAAA;EAVA;AACF;;AAYA;EACC,uBAAA;AATD;;AAWA,oCAAA;AAEA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,uBAAA;EACA,wCAAA;AATD;;AAYE,uBAAA;AACA;EACD,uBAAA;EACA,YAAA;EACA,UAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EAEA,+BAAA;EAOA,oCAAA;EAKA,8BAAA;AApBD;AASC;EACE,oDAAA;EACA,mBAAA;EACA,kBAAA;AAPH;AAWC;EACE,YAAA;AATH;AAaC;EACE,YAAA;AAXH;;AAeE;EACD,YAAA;EACA,WAAA;AAZD;;AAeE,oBAAA;AACA;EACD,aAAA;EACA,mBAAA;EACA,SAAA;AAZD;;AAeE,6BAAA;AACA;EACD,uBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EAEA,+BAAA;EAMA,4BAAA;AAlBD;AAaC;EACE,oDAAA;EACA,mBAAA;AAXH;AAeC;EACE,qCAAA;AAbH;AAgBC;EACE,oCAAA;AAdH;AAiBC;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;AAfH;;AAmBE,+BAAA;AACA;EAmBD,8CAAA;AAlCD;AAgBC;EACE,yBAAA;EACA,gCAAA;EACA,gBAAA;AAdH;AAmBG;;EACD,2BAAA;EACA,mBAAA;AAhBF;AAmBG;;EACD,yBAAA;AAhBF;AAqBC;EACE,yBAAA;AAnBH;;AAuBE,6CAAA;AAED;;;EAGE,oDAAA;EACA,mBAAA;EACA,+CAAA;AArBH","sourcesContent":["@import '../../../theme/mixins';\n\n.header {\n\twidth: 100%;\n\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding-inline: 24px;\n\tbackground-color: white;\n\n\tpadding: 20px 20px;\n\tbox-shadow: 0px -4px 15px 0px #4F614F40;\n\n\t.logo {\n\t\theight: 50px;\n\t\tmax-width: 65px;\n\t}\n\tion-button {\n\t\th4 {\n\t\t\tcolor: white;\n\t\t\ttext-transform: capitalize;\n\t\t\tfont-size: 20px;\n\t\t\tpadding-left: 10px;\n\t\t}\n\t}\n\t.title {\n\t\tfont-size: 16px;\n\t\tcolor: #000;\n\t}\n\tapp-burger-btn {\n\t\t// display: block;\n\t\t// margin-left: auto;\n\t\t// margin-right: -20px;\n\t}\n}\n.flag-item {\n\tmargin-right: 10px;\n\tion-img {\n\t\twidth: 45px;\n\t\tborder: 2px solid var(--ion-color-primary);\n\t\tborder-radius: 50%;\n\t\tpadding: 2px;\n\t}\n}\n\n.block_info {\n\tdisplay: flex;\n\talign-items: center;\n}\n.login {\n\t@include mobile {\n\t\tdisplay: none;\n\t}\n}\n.bsg-logo-button {\n\tbackground: transparent;\n}\n/* BSG-compliant styles for header */\n\n.header {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tpadding: 10px 15px;\n\tbackground-color: white;\n\tbox-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  }\n\n  /* Logo button styles */\n  .bsg-logo-button {\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 0;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\n\t/* Accessibility focus styles */\n\t&:focus {\n\t  outline: 2px solid var(--ion-color-primary, #7EA769);\n\t  outline-offset: 2px;\n\t  border-radius: 4px;\n\t}\n\n\t/* Hover state for visual feedback */\n\t&:hover {\n\t  opacity: 0.9;\n\t}\n\n\t/* Active state when pressed */\n\t&:active {\n\t  opacity: 0.8;\n\t}\n  }\n\n  .logo {\n\theight: 30px;\n\twidth: auto;\n  }\n\n  /* Header controls */\n  .block_info {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 15px;\n  }\n\n  /* Language selector button */\n  .bsg-language-button {\n\tbackground: transparent;\n\tborder: none;\n\tpadding: 5px;\n\tborder-radius: 50%;\n\tcursor: pointer;\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: center;\n\n\t/* Accessibility focus styles */\n\t&:focus {\n\t  outline: 2px solid var(--ion-color-primary, #7EA769);\n\t  outline-offset: 2px;\n\t}\n\n\t/* Hover and active states */\n\t&:hover {\n\t  background-color: rgba(0, 0, 0, 0.05);\n\t}\n\n\t&:active {\n\t  background-color: rgba(0, 0, 0, 0.1);\n\t}\n\n\tion-img {\n\t  width: 45px;\n\t  height: 45px;\n\t  border-radius: 50%;\n\t  overflow: hidden;\n\t}\n  }\n\n  /* High contrast mode support */\n  .bsg-high-contrast {\n\t.header {\n\t  background-color: #000000;\n\t  border-bottom: 2px solid #ffffff;\n\t  box-shadow: none;\n\t}\n\n\t.bsg-logo-button,\n\t.bsg-language-button {\n\t  &:focus {\n\t\toutline: 3px dashed #ffff00;\n\t\toutline-offset: 3px;\n\t  }\n\n\t  &:hover {\n\t\tbackground-color: #333333;\n\t  }\n\t}\n\n\t/* Add border around the flag for visibility */\n\t.bsg-language-button ion-img {\n\t  border: 1px solid #ffffff;\n\t}\n  }\n\n  /* Keyboard navigation mode specific styles */\n  .bsg-keyboard-mode {\n\t.bsg-logo-button:focus,\n\t.bsg-language-button:focus,\n\tapp-burger-btn:focus {\n\t  outline: 2px solid var(--ion-color-primary, #7EA769);\n\t  outline-offset: 2px;\n\t  box-shadow: 0 0 0 4px rgba(126, 167, 105, 0.25);\n\t}\n  }","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
